import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '../../common';

type RenamePropsType = {
  onClick: () => void;
  disabled?: boolean;
};

export const Rename: React.FC<RenamePropsType> = ({ onClick, disabled }) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      leftSection={<FontAwesomeIcon icon={faPencil} />}
      onClick={onClick}
      disabled={disabled}
    >
      {t('FILE_TREE_CONTEXT_MENU.RENAME')}
    </MenuItem>
  );
};
